import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.9978 1.00196L10.998 0.00214157L6.00108 4.9991L1.00198 0L9.38486e-06 1.00197L4.99911 6.00107L0 11.0002L0.999814 12L5.99893 7.00089L10.998 12L12 10.998L7.0009 5.99892L11.9978 1.00196Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol